import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import tEN from "./en.json";
import tUK from "./uk.json";
import tES from "./es.json";
import tPT from "./pt.json";

export const defaultNS = "translation";

export const resources = {
  en: { translation: tEN },
  uk: { translation: tUK },
  es: { translation: tES },
  pt: { translation: tPT },
} as const;

const getSupportedLangs = () =>
  process.env.REACT_APP_INTERFACE_LANGS?.split(",").map((lang) =>
    lang === "ua" ? "uk" : lang
  ) || [];

export const detectLanguage = () => {
  const supportedLangs = getSupportedLangs();

  const savedLang = localStorage.getItem("lang");
  if (savedLang && supportedLangs.includes(savedLang)) {
    return savedLang;
  }

  const fallbackLang = supportedLangs.includes("en") ? "en" : supportedLangs[0];
  localStorage.setItem("lang", fallbackLang);
  return fallbackLang;
};

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
